export default __webpack_public_path__ + "static/media/minus.58e51d4e.svg";